export const createURLParams = data => {
  const params = new URLSearchParams();
  Object.keys(data).forEach(key => {
    const isEmptyArray = Array.isArray(data[key]) && data[key].length === 0;
    if (data[key] != null && data[key] !== '' && !isEmptyArray) {
      params.append(key, data[key]);
    }
  });
  return params;
};

// if pageSize and pageIndex aren't passed in , by default it grabs max 9999 results
export const createPaginationValues = ({ pageSize = 9999, pageIndex = 0 }) => {
  const limit = pageSize;
  const offset = pageIndex * pageSize;
  return { limit, offset };
};
